const ProjectClaimsService = class ProjectClaimsService {
  constructor ($http, Configuration, ModalService, ProjectService, UserService) {
    'ngInject'

    this.$http = $http
    this.Configuration = Configuration
    this.ModalService = ModalService
    this.UserService = UserService
    this.ProjectService = ProjectService
  }

  init () {
    console.log('ProjectClaimsService > init')
  }

  get userClaimCounts () {
    return {
      available: this.UserService.user?.availableClaimCount,
      current: this.UserService.user?.currentClaimCount,
      max: this.UserService.user?.maxClaimCount
    }
  }

  get projectClaimCounts () {
    return {
      available: this.ProjectService.project?.availableClaimCount,
      current: this.ProjectService.project?.currentClaimCount,
      max: this.ProjectService.project?.maxClaimCount
    }
  }

  get claimExpertsNames () {
    if (this.ProjectService.project?.engagementClaims) {
      return this.ProjectService.project?.engagementClaims.map(claim => claim.expert.fullName).join(', ')
    }
    return 'N/A'
  }

  get showClaimExpertsNames () {
    return this.ProjectService.project?.engagementClaims?.length > 0
  }

  // The current expert's own claim on this project (if any).
  get currentExpertClaim () {
    const userId = this.UserService.user?.id
    return this.ProjectService.project?.engagementClaims?.find(claim => claim.expert?.id === userId)
  }

  // Configured engagement window in minutes (BE exposes claimExpiryTimeout on
  // the user object). Used for the pre-claim warning copy.
  get claimExpiryMinutes () {
    return this.UserService.user?.claimExpiryTimeout ?? null
  }

  // UTC datetime the current expert's claim expires, or null when there is
  // no active timer (no claim, or a public comment was already posted).
  get claimExpiresAt () {
    return this.currentExpertClaim?.expiredAt ?? null
  }

  claimProject (projectId) {
    return this.$http
      .post(`${this.Configuration.apiUrl}/experts/projects/engagement_claims`, { projectId })
      .then(response => response.data)
  }

  unclaimProject (projectId) {
    return this.$http
      .delete(`${this.Configuration.apiUrl}/experts/projects/engagement_claims`, {
        params: {
          project_id: projectId
        }
      })
      .then(response => response.data)
  }
}
export default ProjectClaimsService
